import { useCallback } from 'react';
import { useSWRConfig } from 'swr';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Heading,
  Toggle,
  InlineButton,
  Button
} from '@itandi/itandi-bb-ui';
import { useRouter } from 'next/router';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import { PATH as NEW_STAFF_PATH } from '~/pages/settings/staffs/new';
import { PATH as STAFF_PROFILE_PATH } from '~/pages/settings/staffs/[staffId]/profiles';
import { updateEnabled } from '~/utils/api/Staff';
import { generatePath } from '~/utils/generatePath';
import type { Staff } from '~/models/Staff';
import type { ItandiAccount } from '~/models/ItandiAccount';

type Props = {
  staffs: Staff[];
  currentCompany: Exclude<ItandiAccount['company'], null>;
};

export const Page: React.FC<Props> = ({ staffs, currentCompany }) => {
  const router = useRouter();
  const { mutate: globalMutate } = useSWRConfig();

  const updateStaffEnabled = useCallback(
    async (
      staff: Staff,
      e: React.ChangeEvent<HTMLInputElement>
    ): Promise<void> => {
      await updateEnabled(staff.id, e.target.checked);
      globalMutate(generatePath('/staffs'));
    },
    [globalMutate]
  );

  return (
    <DefaultV2>
      <ClientSettingLayout>
        <Heading
          as="h2"
          marginBottom={20}
          rightArea={
            !currentCompany.useIaStaffLogin && (
              <Button
                onClick={() => router.push(NEW_STAFF_PATH)}
                variant="primary"
              >
                追加
              </Button>
            )
          }
        >
          担当者一覧
        </Heading>
        <Table>
          <Thead>
            <Tr>
              <Th width="3rem">有効</Th>
              <Th>担当者</Th>
              <Th>メールアドレス</Th>
              <Th>電話番号</Th>
              <Th>操作</Th>
            </Tr>
          </Thead>
          <Tbody>
            {staffs.map((staff) => {
              const mute = !staff.enabled ? 'Mute' : undefined;
              return (
                <Tr key={staff.id}>
                  <Td bgColor={mute}>
                    <Toggle
                      checked={staff.enabled}
                      onChange={(e) => updateStaffEnabled(staff, e)}
                    />
                  </Td>
                  <Td bgColor={mute}>{staff.name}</Td>
                  <Td bgColor={mute}>{staff.email}</Td>
                  <Td bgColor={mute}>{staff.phoneNumber}</Td>
                  <Td bgColor={mute}>
                    <InlineButton
                      color="link"
                      disabled={!staff.enabled}
                      onClick={() => router.push(STAFF_PROFILE_PATH(staff.id))}
                    >
                      編集
                    </InlineButton>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </ClientSettingLayout>
    </DefaultV2>
  );
};
